
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppCard, AppInput, AppSimpleTable } from '@/components';
import { usePromotionPrototypeDetail } from '@/modules/promotion/prototype/model/detail';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PROTOTYPE.DETAIL,
    components: { AppFormRow, AppCard, AppInput, AppSimpleTable },

    setup() {
        const { model, fetch } = usePromotionPrototypeDetail();

        onMounted(async () => {
            await fetch();
        });

        return { model };
    }
});
